import { createBrowserHistory } from "history";
export const BrowserHistory = createBrowserHistory({
  getUserConfirmation: () => {
    /* Empty callback to block the default browser prompt */
  }
});
